$(document).ready(function () {

    // notification_profile_filter e so um filtro de tela: ajuda o admin a achar
    // usuario na lista de selecao individual, mostrando so o bloco do perfil
    // escolhido. Nunca desmarca quem ja foi selecionado -- e o que permite
    // misturar usuario, professor e prestador na mesma notificacao.
    function notificationUserBlockIds() {
        return $('.users-notification').map(function () { return this.id; }).get();
    }

    function applyNotificationProfileFilter() {
        let selected = $('#notification_profile_filter').val();
        notificationUserBlockIds().forEach(function (id) {
            let isTarget = !selected || id === 'users-notification-' + selected;
            hideElement(id, !isTarget);
        });
    }

    $(document).on('change', '#notification_profile_filter', function () {
        if ($('#notification_send_all').val() === 'true') {
            return;
        }
        applyNotificationProfileFilter();
    });

    $(document).on('change', '#notification_send_all', function () {
        if (this.value == 'true') {
            notificationUserBlockIds().forEach(function (id) { hideElement(id, true); });
        } else {
            applyNotificationProfileFilter();
        }
    });

    let MANAGE_READ_NOTIFICATION = 'read-notification';
    let URL_MANAGE_LIKED_MESSAGE = '/manage_read_notification';

    $(document).on('click', '.' + MANAGE_READ_NOTIFICATION, function () {
        var notification_id = this.id.split("-")[2];
        $.getJSON(
            URL_MANAGE_LIKED_MESSAGE,
            {
                id: notification_id
            },
            function (data) {
                if (data.result == true) {
                    if (data.read == true) {
                        $('.read-notification-' + notification_id).remove();
                    }
                    $(".notifications-icon-number").text(data.quantity);
                } else {
                    alert(data.message);
                }
            });
    });

});
